import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { ChartCard } from '../components/ChartCard';
import { DepartmentCockpit } from '../components/DepartmentCockpit';
import { headcountByDept } from '../lib/mock-data';

export function HrPage() {
  return (
    <div className="pb-12">
      <DepartmentCockpit
        section="hr"
        pageTitle="Human Capital"
        pageEyebrow="People Dashboard"
        pageDescription="Workforce composition, attrition and engagement modeled from HRIS data."
      >
        {() => <HrCharts />}
      </DepartmentCockpit>
    </div>
  );
}

function HrCharts() {
  const data = headcountByDept;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-2">
      <ChartCard
        title="Headcount by Department"
        className="h-[320px]"
      >
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 10, right: 10, left: 30, bottom: 0 }}
          >
            <CartesianGrid
              stroke="var(--color-border)"
              horizontal={false}
            />

            <XAxis
              type="number"
              stroke="var(--color-muted-foreground)"
              fontSize={11}
              tickLine={false}
              axisLine={false}
            />

            <YAxis
              type="category"
              dataKey="dept"
              stroke="var(--color-muted-foreground)"
              fontSize={11}
              tickLine={false}
              axisLine={false}
              width={120}
            />

            <Tooltip
              contentStyle={{
                background: 'var(--color-popover)',
                border: '1px solid var(--color-border)',
                borderRadius: 8,
                fontSize: 12,
              }}
              cursor={{ fill: 'var(--color-border)' }}
            />

            <Bar
              dataKey="count"
              fill="oklch(0.7 0.21 305)"
              radius={[0, 4, 4, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </ChartCard>
    </div>
  );
}
